import { useState } from "react";
import { AlertTriangle, Euro, Gavel, Shield, ArrowRight } from "lucide-react";
import { useContent } from "@/lib/content";

const RISK_ICONS = [Euro, Shield, Gavel, AlertTriangle];
const RISK_COLORS = ["rose", "amber", "rose", "amber"];

export default function RisksCarousel() {
  const [idx, setIdx] = useState(0);
  const { legal } = useContent();
  const r = legal.risks[idx];
  const Icon = RISK_ICONS[idx] || AlertTriangle;
  const color = RISK_COLORS[idx] || "rose";

  return (
    <div data-testid="risks-carousel" className="w-full">
      <p className="text-[10px] sm:text-xs uppercase tracking-widest text-rose-500 font-semibold mb-3">{legal.risksEyebrow}</p>
      <div className="relative bg-gradient-to-br from-rose-50 to-amber-50 border-2 border-rose-200 rounded-2xl p-5 sm:p-8 md:p-10 min-h-[200px] sm:min-h-[220px]">
        <div className="flex flex-col sm:flex-row items-start gap-4 sm:gap-6" key={idx}>
          <div className={`w-12 h-12 sm:w-14 sm:h-14 rounded-xl flex items-center justify-center flex-shrink-0 ${color === "rose" ? "bg-rose-500 text-white" : "bg-amber-500 text-white"}`}>
            <Icon className="w-6 h-6 sm:w-7 sm:h-7" />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-xl sm:text-2xl font-semibold text-slate-900 mb-2 leading-tight">{r.title}</h3>
            <p className="text-sm sm:text-base text-slate-700 leading-relaxed">{r.desc}</p>
          </div>
        </div>
        <div className="flex justify-center gap-2 mt-6">
          {legal.risks.map((_, i) => (
            <button key={i} onClick={() => setIdx(i)} data-testid={`risk-dot-${i}`}
              aria-label={`Risque ${i + 1}`}
              className={`h-2 rounded-full transition-all ${i === idx ? "w-8 bg-rose-500" : "w-2 bg-slate-300 hover:bg-slate-400"}`} />
          ))}
        </div>
      </div>
      <button
        onClick={() => setIdx((idx + 1) % legal.risks.length)}
        data-testid="risk-next"
        className="mt-4 w-full bg-rose-600 hover:bg-rose-700 active:bg-rose-800 text-white font-bold text-base sm:text-lg py-4 sm:py-5 rounded-2xl inline-flex items-center justify-center gap-2 sm:gap-3 shadow-lg shadow-rose-500/30 hover:shadow-xl hover:shadow-rose-500/40 transition-all"
      >
        <span className="tracking-wide">{legal.next}</span>
        <ArrowRight className="w-5 h-5 sm:w-6 sm:h-6" />
      </button>
    </div>
  );
}
